var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.language == 'zh')?_c('videoDom'):_vm._e(),_c('Banner'),_c('Introduction'),_c('Hexinchanping'),(_vm.language == 'zh')?_c('News'):_vm._e(),_c('Partner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }